document.addEventListener('DOMContentLoaded', function () {
  const gameSection = document.querySelector('.memory-game-section');
  if (!gameSection) return;

  const levels = [
    { level: 1, pairs: 6, previewTime: 2500, columns: 4, timeLimit: 999 },
    { level: 2, pairs: 8, previewTime: 1800, columns: 4, timeLimit: 120 }
  ];

  const imagePool = [
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/1.jpg?v=1775465371',
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/2.jpg?v=1775465351',
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/3.jpg?v=1775465351',
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/4.jpg?v=1775465355',
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/5.jpg?v=1775465378',
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/6.jpg?v=1775465377',
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/7.jpg?v=1775465373',
    'https://cdn.shopify.com/s/files/1/0071/2474/6324/files/8.jpg?v=1775465351'
  ];

  const maxLives = 15;
  const STORAGE_KEY_CLAIMED = 'memory_game_voucher_claimed';
  const STORAGE_KEY_CODE = 'memory_game_voucher_code';

  const intro = document.getElementById('gameIntro');
  const gameUI = document.getElementById('gameUI');
  const memoryGrid = document.getElementById('memoryGrid');
  const startBtn = document.getElementById('startGameBtn');
  const restartBtn = document.getElementById('restartBtn');

  const levelDisplay = document.getElementById('levelDisplay');
  const timeDisplay = document.getElementById('timeDisplay');
  const movesDisplay = document.getElementById('movesDisplay');
  const livesDisplay = document.getElementById('livesDisplay');
  const gameMessage = document.getElementById('gameMessage');

  const levelOverlay = document.getElementById('levelOverlay');
  const overlayTitle = document.getElementById('overlayTitle');
  const overlayText = document.getElementById('overlayText');
  const overlayBtn = document.getElementById('overlayBtn');

  const rewardOverlay = document.getElementById('rewardOverlay');
  const rewardHeading = document.getElementById('rewardHeading');
  const rewardText = document.getElementById('rewardText');
  const rewardCode = document.getElementById('rewardCode');
  const copyRewardBtn = document.getElementById('copyRewardBtn');
  const downloadRewardBtn = document.getElementById('downloadRewardBtn');
  const playAgainBtn = document.getElementById('playAgainBtn');
  
  let currentLevel = 0;
  let cards = [];
  let flippedCards = [];
  let matchedPairs = 0;
  let moves = 0;
  let timer = 0;
  let timerInterval = null;
  let boardLocked = false;
  let lives = maxLives;

  if (imagePool.length < 8) {
    console.error('Memory game needs at least 8 images.');
    return;
  }

  function shuffle(array) {
    const newArray = [...array];
    for (let i = newArray.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [newArray[i], newArray[j]] = [newArray[j], newArray[i]];
    }
    return newArray;
  }

  function getGridSizing() {
    let cardWidth = 120;
    let gap = 14;

    if (window.innerWidth <= 1100) {
      cardWidth = 84;
      gap = 10;
    } else if (window.innerWidth <= 1280) {
      cardWidth = 96;
      gap = 10;
    } else if (window.innerWidth <= 1440) {
      cardWidth = 108;
      gap = 12;
    }

    return { cardWidth, gap };
  }

  function applyGridSizing(columns) {
    const { cardWidth, gap } = getGridSizing();

    memoryGrid.style.gridTemplateColumns = `repeat(${columns}, ${cardWidth}px)`;
    memoryGrid.style.gap = `${gap}px`;
    memoryGrid.style.maxWidth = `${(columns * cardWidth) + ((columns - 1) * gap)}px`;
    memoryGrid.style.width = '100%';
    memoryGrid.style.margin = '0 auto';
  }

  function resetLevelState() {
    moves = 0;
    timer = 0;
    matchedPairs = 0;
    flippedCards = [];
    boardLocked = true;
  }

  function generateVoucherCode() {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ2345689!@#$%&';
    let code = '7$';

    for (let i = 0; i < 8; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }

    return code;
  }

  function hasClaimedVoucher() {
    return localStorage.getItem(STORAGE_KEY_CLAIMED) === 'true';
  }

  function getSavedVoucherCode() {
    return localStorage.getItem(STORAGE_KEY_CODE) || '';
  }

  function saveVoucherCode(code) {
    localStorage.setItem(STORAGE_KEY_CLAIMED, 'true');
    localStorage.setItem(STORAGE_KEY_CODE, code);
  }

  function getOrCreateVoucherCode() {
    const existingCode = getSavedVoucherCode();
    if (existingCode) return existingCode;

    const newCode = generateVoucherCode();
    saveVoucherCode(newCode);
    return newCode;
  }


  function downloadVoucherImage(code) {
    const canvas = document.createElement('canvas');
    canvas.width = 1200;
    canvas.height = 700;

    const ctx = canvas.getContext('2d');
    const now = new Date();
    const dateText = now.toLocaleDateString();

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    const gradient = ctx.createLinearGradient(0, 0, canvas.width, canvas.height);
    gradient.addColorStop(0, '#EC028C');
    gradient.addColorStop(1, '#EC028C');
    ctx.fillStyle = gradient;
    ctx.fillRect(60, 60, canvas.width - 120, canvas.height - 120);

    ctx.fillStyle = '#ffffff';
    ctx.font = 'bold 54px Arial';
    ctx.textAlign = 'center';
    ctx.fillText('Memory Game Voucher', canvas.width / 2, 180);

    ctx.font = '32px Arial';
    ctx.fillText('Show this voucher at the branch', canvas.width / 2, 250);

    ctx.fillStyle = '#ffffff';
    ctx.fillRect(220, 320, 760, 140);

    ctx.fillStyle = '#000000';
    ctx.font = 'bold 68px Arial';
    ctx.fillText(code, canvas.width / 2, 410);

    ctx.fillStyle = '#ffffff';
    ctx.font = '26px Arial';
    ctx.fillText(`Generated on ${dateText}`, canvas.width / 2, 540);
    ctx.fillText('One voucher per winner', canvas.width / 2, 590);

    const link = document.createElement('a');
    link.download = `${code}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  }

  function startGame() {
    clearInterval(timerInterval);

    intro.classList.add('hidden');
    gameUI.classList.remove('hidden');
    rewardOverlay.classList.add('hidden');
    levelOverlay.classList.add('hidden');

    currentLevel = 0;
    lives = maxLives;

    startLevel();
  }

  function startLevel() {
    clearInterval(timerInterval);

    const config = levels[currentLevel];
    resetLevelState();

    levelDisplay.textContent = config.level;
    timeDisplay.textContent = timer;
    movesDisplay.textContent = moves;
    livesDisplay.textContent = lives;
    gameMessage.textContent = `Level ${config.level}: Memorize the cards before they flip.`;

    const selectedImages = imagePool.slice(0, config.pairs);
    cards = shuffle([...selectedImages, ...selectedImages]);

    renderBoard(config);
    revealAllCards();

    setTimeout(function () {
      hideAllCards();
      boardLocked = false;
      startTimer();
      gameMessage.textContent = `Level ${config.level}: Match all pairs before you lose all lives.`;
    }, config.previewTime);
  }

  function renderBoard(config) {
    memoryGrid.innerHTML = '';
    applyGridSizing(config.columns);

    cards.forEach(function (imageUrl, index) {
      const card = document.createElement('button');
      card.className = 'memory-card flipped';
      card.dataset.image = imageUrl;
      card.dataset.index = index;
      card.type = 'button';
      card.setAttribute('aria-label', 'Memory card');

      card.innerHTML = `
        <div class="memory-card-inner">
          <div class="memory-card-face memory-card-front">?</div>
          <div class="memory-card-face memory-card-back">
            <img src="${imageUrl}" alt="Memory card image">
          </div>
        </div>
      `;

      card.addEventListener('click', handleCardClick);
      memoryGrid.appendChild(card);
    });
  }

  function revealAllCards() {
    document.querySelectorAll('.memory-card').forEach(function (card) {
      card.classList.add('flipped');
    });
  }

  function hideAllCards() {
    document.querySelectorAll('.memory-card').forEach(function (card) {
      card.classList.remove('flipped');
    });
  }

  function startTimer() {
    const config = levels[currentLevel];

    timerInterval = setInterval(function () {
      timer += 1;
      timeDisplay.textContent = timer;

      if (timer >= config.timeLimit) {
        clearInterval(timerInterval);
        loseGame(`Time is up on Level ${config.level}.`);
      }
    }, 1000);
  }

  function handleCardClick(event) {
    const card = event.currentTarget;
    const config = levels[currentLevel];

    if (
      boardLocked ||
      card.classList.contains('flipped') ||
      card.classList.contains('matched')
    ) {
      return;
    }

    card.classList.add('flipped');
    flippedCards.push(card);

    if (flippedCards.length !== 2) return;

    boardLocked = true;
    moves += 1;
    movesDisplay.textContent = moves;

    const firstCard = flippedCards[0];
    const secondCard = flippedCards[1];

    if (firstCard.dataset.image === secondCard.dataset.image) {
      firstCard.classList.add('matched');
      secondCard.classList.add('matched');
      flippedCards = [];
      matchedPairs += 1;
      boardLocked = false;

      if (matchedPairs === config.pairs) {
        clearInterval(timerInterval);

        if (currentLevel < levels.length - 1) {
          showLevelComplete();
        } else {
          showReward();
        }
      }

      return;
    }

    lives -= 1;
    livesDisplay.textContent = lives;

    if (lives <= 0) {
      clearInterval(timerInterval);
      loseGame(`You lost all ${maxLives} lives on Level ${config.level}.`);
      return;
    }

    setTimeout(function () {
      firstCard.classList.remove('flipped');
      secondCard.classList.remove('flipped');
      flippedCards = [];
      boardLocked = false;
    }, 800);
  }

  function showLevelComplete() {
    overlayTitle.textContent = `Level ${levels[currentLevel].level} Complete`;
    overlayText.textContent = `Great job. You still have ${lives} lives left.`;
    overlayBtn.textContent = 'Continue';
    levelOverlay.classList.remove('hidden');
  }

  function loseGame(message) {
    overlayTitle.textContent = 'Game Over';
    overlayText.textContent = message;
    overlayBtn.textContent = 'Play Again';
    levelOverlay.classList.remove('hidden');
  }

  function showReward() {
    const alreadyClaimed = hasClaimedVoucher();
    const code = getOrCreateVoucherCode();

    rewardCode.textContent = code;

    if (alreadyClaimed) {
      rewardHeading.textContent = 'Voucher Already Claimed';
      rewardText.textContent = 'You already won before. You can keep playing, but this is your same saved voucher.';
    } else {
      rewardHeading.textContent = 'You Won 🎉';
      rewardText.textContent = 'Copy or download your unique voucher and show it at the branch.';
    }

    rewardOverlay.classList.remove('hidden');
  }

  startBtn.addEventListener('click', startGame);

  restartBtn.addEventListener('click', function () {
    startGame();
  });

  overlayBtn.addEventListener('click', function () {
    levelOverlay.classList.add('hidden');

    if (overlayTitle.textContent === 'Game Over') {
      startGame();
      return;
    }

    currentLevel += 1;
    startLevel();
  });

  playAgainBtn.addEventListener('click', function () {
    startGame();
  });

  copyRewardBtn.addEventListener('click', function () {
    navigator.clipboard.writeText(rewardCode.textContent).then(function () {
      copyRewardBtn.textContent = 'Copied';
      setTimeout(function () {
        copyRewardBtn.textContent = 'Copy Code';
      }, 1500);
    }).catch(function () {
      copyRewardBtn.textContent = 'Copy Manually';
    });
  });

  downloadRewardBtn.addEventListener('click', function () {
    downloadVoucherImage(rewardCode.textContent.trim());
  });

  window.addEventListener('resize', function () {
    if (!gameUI.classList.contains('hidden')) {
      applyGridSizing(levels[currentLevel].columns);
    }
  });
});